const ValueItemCard = ({
  icon,
  title,
  description,
}: {
  icon: string;
  title: string;
  description: string;
}) => (
  <div className="text-center">
    <div className="bg-gray-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-6">
      <span className="text-2xl">{icon}</span>
    </div>
    <h3 className="text-lg md:text-xl font-semibold mb-4 text-gray-900">
      {title}
    </h3>
    <p className="text-gray-600 leading-relaxed">{description}</p>
  </div>
);

export default ValueItemCard;
